import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  width: fit-content;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import NextLink from "next/link";
import styled from "styled-components";
import getExternalLinkProps from "../../util/getExternalLinkProps";
import Text from "../Text/Text";
var StyledLink = styled(Text).withConfig({
    componentId: "sc-67d03ccc-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.isDark ? "\n    &:hover{\n      color: ".concat(theme.colors.text, "\n    }\n  ") : "\n    &:hover{\n      color: ".concat(theme.colors.success, "\n    }\n  ");
});
var Link = function(_param) {
    var external = _param.external, href = _param.href, props = _object_without_properties(_param, [
        "external",
        "href"
    ]);
    var internalProps = external ? getExternalLinkProps() : {};
    if (external) {
        return /*#__PURE__*/ _jsx(StyledLink, _object_spread({
            as: "a",
            href: href,
            bold: true
        }, internalProps, props));
    } else {
        return /*#__PURE__*/ _jsx(NextLink, {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ _jsx(StyledLink, _object_spread({
                as: "a",
                bold: true
            }, props))
        });
    }
};
/* eslint-disable react/default-props-match-prop-types */ Link.defaultProps = {
    color: "primary"
};
export default Link;
